import type { LucideIcon } from 'lucide-react';
import { DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';
import { ACCENT_MARK_CLASS } from '@/styles/accentMark';
import { SOFT_BLUE_GRADIENT_CLASS } from '@/styles/softBlueSurface';

const HEADER_CLASS = cn(
  '-mx-4 -mt-4 flex items-start gap-3 rounded-t-2xl border-b border-primary/10 py-4 pr-12 pl-4',
  SOFT_BLUE_GRADIENT_CLASS,
);

const ICON_TILE_CLASS = cn(
  'flex size-10 shrink-0 items-center justify-center rounded-xl',
  ACCENT_MARK_CLASS,
);

interface FormDialogHeaderProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

export function FormDialogHeader({ icon: Icon, title, description }: FormDialogHeaderProps) {
  return (
    <div className={HEADER_CLASS}>
      <span className={ICON_TILE_CLASS}>
        <Icon className="size-5" aria-hidden />
      </span>
      <div className="flex min-w-0 flex-col gap-1.5">
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
      </div>
    </div>
  );
}
